import { Context } from "./Reducers/Store";
import React, { useContext } from "react";
import { useLocation, Navigate } from "react-router-dom";
import AlertComponent from "./components/AlertComponent";

function RequireAuth({ children, roles = [], companyAdmin = null, workspaceAdmin = null }) {
    const [state, dispatch] = useContext(Context);
    let location = useLocation();

    if (!state.isLogged) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // if (state.profile?.tipo_usuario === 'ContaUsuario') {
    //     localStorage.removeItem("jwt");
    //     localStorage.removeItem("refreshToken");
    //     dispatch({ type: "SET_LOGGED", payload: null });
    //     AlertComponent("Error", "Você não tem permissão para acessar este sistema.", { icon: "error" });
    //     return <Navigate to="/login" replace />;
    // }

    debugger;
    let hasUnauthorizedAccess = (roles != null && roles.length > 0) || companyAdmin != null || workspaceAdmin != null;

    // Validate roles
    if (roles != null && roles.length > 0) {
        hasUnauthorizedAccess = !roles.map(item => item.toLowerCase()).includes(state.profile?.tipo_usuario?.toLowerCase());
    }

    if (hasUnauthorizedAccess) {
        AlertComponent("Error", "UNAUTHORIZED_ACCESS", { icon: "error" });
        return <Navigate to="/" replace />;
    }

    return children;
}

export default RequireAuth;